import InputCreatableView from './InputCreatableView';

export default InputCreatableView;
